export const KIND = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
}
